import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import Section7 from '../section7';


function Home() {
  return (
    <>    
      <Section7 />
      <Footer /> 
    </>
  );
}

export default Home;
